import React, { useEffect } from 'react';
import Loader from '../../../organisms/loader/Loader';
import { API_ENDPOINTS, CONSTS } from '../../utils/endpoints';
import { DISPLAY_STYLES } from './IndexPage';
import { http_get } from '../../utils/api_client';
import { useDispatch } from 'react-redux';
import LMGrid from '../../../organisms/grid/LMGrid';
import MaterialsTable from '../../../organisms/table/MaterialsTable';
import { fetchCompanyDetails } from '../../../../redux/companySlice';

// BL-084 — fetches the company's checklists via the shared learning-materials
// list endpoint filtered to category=checklists, then renders the shared grid.
const Checklists = ({ displayStyle }) => {
  const dispatch = useDispatch();
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  useEffect(() => {
    dispatch(fetchCompanyDetails());
    setLoading(true);
    http_get(API_ENDPOINTS.GET_LEARNING_MATERIALS, { category: CONSTS.CHECKLISTS })
      .then((response) => setData(response.data || []))
      .catch(() => setData([]))
      .finally(() => setLoading(false));
  }, []);

  const renderGrid = () => <LMGrid data={data} />;

  const renderEmpty = () => (
    <div className="cl-index-empty">
      <h3>No checklists yet</h3>
      <p>Create a checklist to compile paths, walkthroughs, and knowledge bases into one assignable plan.</p>
    </div>
  );

  if (loading) return <Loader />;
  if (!data || data.length === 0) return renderEmpty();

  return (
    <div>
      {displayStyle === DISPLAY_STYLES.LIST
        ? <MaterialsTable data={data} setUpdatedData={setData} />
        : renderGrid()}
    </div>
  );
};

export default Checklists;
